import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-495b1f18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"flex":"1","display":"flex","flex-direction":"column","overflow":"hidden"} }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3",
  style: {"background-color":"rgb(200, 222, 255)"}
}
const _hoisted_4 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-24 ss-sombra-suave",
  style: {"display":"flex","align-items":"center","justify-content":"center","height":"100%"}
}
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_6 = {
  class: "ant-row",
  style: {"background-color":"rgb(200, 222, 255)","height":"45px","padding-left":"12px"}
}
const _hoisted_7 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-6",
  style: {"display":"flex","align-items":"center","gap":"8px","padding-left":"8px"}
}
const _hoisted_8 = { style: {"font-size":"20px"} }
const _hoisted_9 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-6",
  style: {"display":"flex","align-items":"center","gap":"8px","padding-left":"8px"}
}
const _hoisted_10 = { style: {"font-size":"20px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap","min-width":"0","flex":"1"} }
const _hoisted_11 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-6",
  style: {"display":"flex","align-items":"center","gap":"8px","padding-left":"8px"}
}
const _hoisted_12 = { style: {"font-size":"20px"} }
const _hoisted_13 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-6",
  style: {"display":"flex","align-items":"center","gap":"8px","padding-left":"8px"}
}
const _hoisted_14 = { style: {"font-size":"20px"} }
const _hoisted_15 = {
  class: "ant-row ss-venda-dados-principais",
  style: {"background-color":"rgb(230, 240, 255)"}
}
const _hoisted_16 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-5 ss-movimento-comercial-campo-totalizador",
  style: {"padding":"10px 10px"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"18px"} }, "Nova Venda [Shift + N]", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-1" }, null, -1))
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-5 ss-movimento-comercial-campo-totalizador" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"18px"} }, "Finalizar Venda [Shift + F]", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-1" }, null, -1))
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-5 ss-movimento-comercial-campo-totalizador" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"18px"} }, "Cliente [ Shift + P ]", -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-movimento-comercial-campo-totalizador" }
const _hoisted_28 = { style: {"font-size":"18px"} }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  class: "ant-row ss-sombra-suave",
  style: {"min-height":"calc(18vh - 1px)","border":"1px solid #000066","border-radius":"2px","padding":"2px","align-items":"center"}
}
const _hoisted_31 = {
  class: "ant-col ant-col-xs-12 ant-col-xl-12",
  style: {"height":"100%","padding":"0","border-radius":"6px 0 0 6px"}
}
const _hoisted_32 = {
  class: "ant-col ant-col-xs-12 ant-col-xl-12",
  style: {"height":"100%","padding":"8px","display":"flex","flex-direction":"column","justify-content":"center","background-color":"#00bfff","border-radius":"0 6px 6px 0"}
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"white","text-align":"center","font-weight":"bold","font-size":"34px"} }, " TOTAL ", -1))
const _hoisted_34 = ["value"]
const _hoisted_35 = {
  class: "ant-row",
  style: {"min-height":"calc(63vh - 1px)"}
}
const _hoisted_36 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-12",
  style: {"border":"1px solid #000066","border-radius":"6px","padding":"8px","align-items":"center"}
}
const _hoisted_37 = {
  class: "ant-row",
  style: {"height":"110px"}
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-1 ant-col-xl-1" }, null, -1))
const _hoisted_39 = { class: "ant-col ant-col-xs-8 ant-col-xl-6" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"larger"} }, "Código", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-1 ant-col-xl-1" }, null, -1))
const _hoisted_42 = { class: "ant-col ant-col-xs-12 ant-col-xl-14" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"large"} }, "Descrição", -1))
const _hoisted_44 = {
  class: "ant-row",
  style: {"height":"110px"}
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-1 ant-col-xl-1" }, null, -1))
const _hoisted_46 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"larger"} }, "Quantidade", -1))
const _hoisted_48 = ["value"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-1 ant-col-xl-1" }, null, -1))
const _hoisted_50 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"larger"} }, " Valor Unitário R$ ", -1))
const _hoisted_52 = ["value"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-1 ant-col-xl-1" }, null, -1))
const _hoisted_54 = { class: "ant-col ant-col-xs-7 ant-col-xl-7" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"larger"} }, " Valor Total R$ ", -1))
const _hoisted_56 = ["value"]
const _hoisted_57 = { class: "ant-row" }
const _hoisted_58 = { class: "ss-img-container" }
const _hoisted_59 = ["src"]
const _hoisted_60 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-12",
  style: {"border":"1px solid #000066","border-radius":"6px","padding":"8px","align-items":"center"}
}
const _hoisted_61 = {
  class: "ant-col ant-col-xs-12 ant-col-xl-12",
  style: {"font-size":"medium"}
}
const _hoisted_62 = {
  class: "ant-col ant-col-xs-4 ant-col-xl-6",
  style: {"font-size":"medium"}
}
const _hoisted_63 = {
  class: "ant-col ant-col-xs-6 ant-col-xl-4",
  style: {"font-size":"medium"}
}
const _hoisted_64 = {
  class: "ant-col ant-col-xs-2 ant-col-xl-2",
  style: {"text-align":"medium"}
}
const _hoisted_65 = { class: "acoes-item" }
const _hoisted_66 = ["onClick"]
const _hoisted_67 = ["onClick"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-venda-dados-principais" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-6 ant-col-xl-12" }, "Descrição"),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-4 ant-col-xl-4" }, "Qtd x Valor Unitário"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col ant-col-xs-6 ant-col-xl-6",
    style: {"text-align":"center"}
  }, "Valor Total"),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-2 ant-col-xs-2" }, "Ações")
], -1))
const _hoisted_69 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_selecionar_produto_frente_caixa = _resolveComponent("selecionar-produto-frente-caixa")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_frente_caixa_detalhe_pagamento = _resolveComponent("frente-caixa-detalhe-pagamento")!
  const _component_frente_caixa_desconto_modal = _resolveComponent("frente-caixa-desconto-modal")!
  const _component_selecionar_cliente_modal = _resolveComponent("selecionar-cliente-modal")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_selecionar_abertura_caixa_modal = _resolveComponent("selecionar-abertura-caixa-modal")!
  const _component_fechamento_caixa_modal = _resolveComponent("fechamento-caixa-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: "100%",
    footer: false,
    "wrap-class-name": 'full-modal ss-modal-vendas scroll-modal ss-modal-vendas',
    bodyStyle: { padding: 0, height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_image, {
                src: "/static/img/ss-logo.png",
                style: {"height":"100px"},
                preview: false
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_icone, {
                  nome: "monitor",
                  style: {"height":"24px"}
                }),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.props.aberturaCaixa.descricaoCaixa), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_icone, {
                  nome: "cliente",
                  style: {"height":"24px"}
                }),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.props.aberturaCaixa.nomeOperador), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_icone, {
                  nome: "calendario",
                  style: {"height":"24px"}
                }),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.dataAtual), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_icone, {
                  nome: "relogio",
                  style: {"height":"24px"}
                }),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.horaAtual), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-secondary",
                  style: {"color":"#000080","background-color":"aliceblue"},
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.realizarNovaVenda && _ctx.realizarNovaVenda(...args)))
                }, _hoisted_18)
              ]),
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-secondary",
                  style: {"color":"#000080","background-color":"aliceblue"},
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.finalizar && _ctx.finalizar(...args)))
                }, _hoisted_22)
              ]),
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-secondary",
                  style: {"color":"#000080","background-color":"aliceblue"},
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.abrirCliente && _ctx.abrirCliente(...args)))
                }, _hoisted_26)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-secondary",
                  style: {"color":"#000080","background-color":"aliceblue"},
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.fechar && _ctx.fechar(...args)))
                }, [
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.state.textoBotao) + " [ Shift + E ]", 1)
                ])
              ])
            ])
          ])
        ]),
        (!_ctx.state.exibirFechamentoVenda)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_selecionar_produto_frente_caixa, {
                    ref: "refSelecionarProduto",
                    empresas: [_ctx.dadosEmpresa.codigoEmpresa],
                    codigoSelecionado: _ctx.state.itemSelecionado.itemNotaFiscal.codigoProdutoDefinicao,
                    "onUpdate:codigoSelecionado": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.itemSelecionado.itemNotaFiscal.codigoProdutoDefinicao) = $event)),
                    descricao: _ctx.state.itemSelecionado.itemNotaFiscal.descricao,
                    "onUpdate:descricao": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.itemSelecionado.itemNotaFiscal.descricao) = $event)),
                    codigoUnidadePrincipal: _ctx.state.itemSelecionado.itemNotaFiscal.codigoUnidadePrincipal,
                    "onUpdate:codigoUnidadePrincipal": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.itemSelecionado.itemNotaFiscal.codigoUnidadePrincipal) = $event)),
                    fatorUnidadePrincipal: _ctx.state.itemSelecionado.itemNotaFiscal.fatorUnidadePrincipal,
                    "onUpdate:fatorUnidadePrincipal": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.itemSelecionado.itemNotaFiscal.fatorUnidadePrincipal) = $event)),
                    codigoInterno: _ctx.state.itemSelecionado.itemNotaFiscal.codigoProduto,
                    "onUpdate:codigoInterno": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.itemSelecionado.itemNotaFiscal.codigoProduto) = $event)),
                    codigoBarras: _ctx.state.itemSelecionado.itemNotaFiscal.codigoBarras,
                    "onUpdate:codigoBarras": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.itemSelecionado.itemNotaFiscal.codigoBarras) = $event)),
                    origemMercadoria: _ctx.state.itemSelecionado.itemNotaFiscal.impostos.origemMercadoria,
                    "onUpdate:origemMercadoria": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.itemSelecionado.itemNotaFiscal.impostos.origemMercadoria) = $event)),
                    codigoNcm: _ctx.state.itemSelecionado.itemNotaFiscal.impostos.codigoNcm,
                    "onUpdate:codigoNcm": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.itemSelecionado.itemNotaFiscal.impostos.codigoNcm) = $event)),
                    ncm: _ctx.state.itemSelecionado.itemNotaFiscal.impostos.ncm,
                    "onUpdate:ncm": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.itemSelecionado.itemNotaFiscal.impostos.ncm) = $event)),
                    emDigitacao: _ctx.state.itemSelecionado.emDigitacao,
                    "onUpdate:emDigitacao": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.itemSelecionado.emDigitacao) = $event)),
                    valorProduto: _ctx.state.itemSelecionado.itemNotaFiscal.precoUnitario,
                    "onUpdate:valorProduto": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.itemSelecionado.itemNotaFiscal.precoUnitario) = $event)),
                    codigoItemTabelaPreco: _ctx.state.itemSelecionado.codigoTabelaPrecoItemProduto,
                    "onUpdate:codigoItemTabelaPreco": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.itemSelecionado.codigoTabelaPrecoItemProduto) = $event)),
                    siglaUnidade: _ctx.state.itemSelecionado.itemNotaFiscal.siglaUnidade,
                    "onUpdate:siglaUnidade": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.itemSelecionado.itemNotaFiscal.siglaUnidade) = $event)),
                    quantidade: _ctx.state.itemSelecionado.itemNotaFiscal.quantidade,
                    "onUpdate:quantidade": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.itemSelecionado.itemNotaFiscal.quantidade) = $event)),
                    codigoItemEstoque: _ctx.state.estoqueItem,
                    "onUpdate:codigoItemEstoque": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.estoqueItem) = $event)),
                    tabelaPreco: _ctx.state.tipoOperacao.codigoTabelaPreco,
                    tipoPreco: _ctx.state.tipoOperacao.codigoTipoPreco,
                    codigoEstoque: _ctx.props.dadosPadraoFrenteCaixa.codigoEstoque,
                    disabled: !_ctx.props.editavel,
                    limparSelecao: false,
                    onChange: _ctx.obterDadosFiscaisProduto,
                    onValorDigitado: _ctx.SalvarItem
                  }, null, 8, ["empresas", "codigoSelecionado", "descricao", "codigoUnidadePrincipal", "fatorUnidadePrincipal", "codigoInterno", "codigoBarras", "origemMercadoria", "codigoNcm", "ncm", "emDigitacao", "valorProduto", "codigoItemTabelaPreco", "siglaUnidade", "quantidade", "codigoItemEstoque", "tabelaPreco", "tipoPreco", "codigoEstoque", "disabled", "onChange", "onValorDigitado"])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("input", {
                    type: "text",
                    class: "ant-input hidden ss-movimento-input-totalizador",
                    style: {"background-color":"#000066","color":"white","font-weight":"900","font-size":"45px","height":"48px","margin-top":"8px","text-align":"center"},
                    value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.venda.notaFiscal.totalNotaFiscal, 2, true),
                    disabled: "true"
                  }, null, 8, _hoisted_34)
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "ant-input ss-venda-dados-principais",
                        style: {"font-size":"larger"},
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.codigoBarras) = $event)),
                        disabled: true
                      }, null, 512), [
                        [_vModelText, _ctx.state.item.itemNotaFiscal.codigoBarras]
                      ])
                    ]),
                    _hoisted_41,
                    _createElementVNode("div", _hoisted_42, [
                      _hoisted_43,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "ant-input ss-venda-dados-principais",
                        style: {"font-size":"larger"},
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.descricao) = $event)),
                        disabled: true
                      }, null, 512), [
                        [_vModelText, _ctx.state.item.itemNotaFiscal.descricao]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createElementVNode("div", _hoisted_46, [
                      _hoisted_47,
                      _createElementVNode("input", {
                        type: "text",
                        class: "ant-input ss-venda-dados-principais",
                        style: {"font-size":"larger"},
                        value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.itemNotaFiscal.quantidade, 2),
                        disabled: true
                      }, null, 8, _hoisted_48)
                    ]),
                    _hoisted_49,
                    _createElementVNode("div", _hoisted_50, [
                      _hoisted_51,
                      _createElementVNode("input", {
                        type: "text",
                        class: "ant-input ss-venda-dados-principais",
                        style: {"font-size":"larger"},
                        value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.itemNotaFiscal.precoUnitario, 2, true),
                        disabled: true
                      }, null, 8, _hoisted_52)
                    ]),
                    _hoisted_53,
                    _createElementVNode("div", _hoisted_54, [
                      _hoisted_55,
                      _createElementVNode("input", {
                        type: "text",
                        class: "ant-input ss-venda-dados-principais",
                        style: {"font-size":"larger"},
                        value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.itemNotaFiscal.valorTotal, 2, true) ,
                        disabled: true
                      }, null, 8, _hoisted_56)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      (_ctx.UtilitarioGeral.valorValido(_ctx.storeSistema.getters.imagemUsuarioAutenticado()))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.storeSistema.getters.imagemUsuarioAutenticado()
                          }, null, 8, _hoisted_59))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", {
                    ref: "listaContainer",
                    class: "ss-scroll-container",
                    tabindex: "0",
                    onKeydown: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.handleKeydown && _ctx.handleKeydown(...args)))
                  }, [
                    _createVNode(_component_a_list, {
                      size: "large",
                      "data-source": _ctx.state.venda.itens
                    }, {
                      renderItem: _withCtx(({ item, index }) => [
                        (_openBlock(), _createBlock(_component_a_list_item, {
                          key: item.itemNotaFiscal.codigoProdutoDefinicao,
                          class: _normalizeClass(['list-item', { 'list-item--selected': _ctx.state.indexSelecionado === index }]),
                          onClick: ($event: any) => (_ctx.state.indexSelecionado = index)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_61, _toDisplayString(item.itemNotaFiscal.codigoProduto) + " - " + _toDisplayString(item.itemNotaFiscal.descricao), 1),
                            _createElementVNode("span", _hoisted_62, _toDisplayString(item.itemNotaFiscal.quantidade) + " * " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(item.itemNotaFiscal.precoUnitario, 2, true)), 1),
                            _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(item.itemNotaFiscal.valorTotal, 2, true)), 1),
                            _createElementVNode("div", _hoisted_64, [
                              _createElementVNode("div", _hoisted_65, [
                                _createElementVNode("a", {
                                  onClick: ($event: any) => (_ctx.excluirItem(index))
                                }, [
                                  _createVNode(_component_icone, { nome: "excluir" })
                                ], 8, _hoisted_66),
                                _createElementVNode("a", {
                                  onClick: ($event: any) => (_ctx.adicionarDesconto(index))
                                }, [
                                  _createVNode(_component_icone, { nome: "dinheiro" })
                                ], 8, _hoisted_67)
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["class", "onClick"]))
                      ]),
                      header: _withCtx(() => [
                        _hoisted_68
                      ]),
                      _: 1
                    }, 8, ["data-source"])
                  ], 544)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_69, [
              _createVNode(_component_frente_caixa_detalhe_pagamento, {
                visivel: _ctx.state.exibirFechamentoVenda,
                "onUpdate:visivel": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.exibirFechamentoVenda) = $event)),
                venda: _ctx.state.venda,
                "onUpdate:venda": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.venda) = $event)),
                "tipos-documentos": _ctx.state.tiposDocumentos,
                onConfirmar: _ctx.adicionarTaxasPagamento,
                caixa: _ctx.state.caixa
              }, null, 8, ["visivel", "venda", "tipos-documentos", "onConfirmar", "caixa"])
            ]))
      ]),
      _createVNode(_component_frente_caixa_desconto_modal, {
        visivel: _ctx.state.exibirDesconto,
        "onUpdate:visivel": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.exibirDesconto) = $event)),
        item: _ctx.state.produtoSelecionado,
        "onUpdate:item": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.produtoSelecionado) = $event)),
        onConfirmar: _cache[26] || (_cache[26] = ($event: any) => (_ctx.concluirDesconto()))
      }, null, 8, ["visivel", "item"]),
      _createVNode(_component_selecionar_cliente_modal, {
        visivel: _ctx.state.exibirSelecionarCliente,
        "onUpdate:visivel": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.exibirSelecionarCliente) = $event)),
        codigoPessoa: _ctx.state.venda.notaFiscal.destinatario.codigoPessoa,
        "onUpdate:codigoPessoa": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.venda.notaFiscal.destinatario.codigoPessoa) = $event)),
        codigoCliente: _ctx.state.venda.codigoCliente,
        "onUpdate:codigoCliente": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.venda.codigoCliente) = $event)),
        empresa: _ctx.dadosEmpresa.codigoEmpresa,
        onConfirmar: _cache[30] || (_cache[30] = ($event: any) => (_ctx.atualizarInformacoesPessoa(true)))
      }, null, 8, ["visivel", "codigoPessoa", "codigoCliente", "empresa"]),
      (_ctx.state.abriuPDF)
        ? (_openBlock(), _createBlock(_component_preview_pdf, {
            key: 0,
            arquivos: _ctx.state.arquivosPdf,
            onFechado: _ctx.focusCampoProduto
          }, null, 8, ["arquivos", "onFechado"]))
        : _createCommentVNode("", true),
      _createVNode(_component_selecionar_abertura_caixa_modal, {
        visivel: _ctx.state.exibirAberturaCaixa,
        "onUpdate:visivel": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.exibirAberturaCaixa) = $event)),
        empresa: _ctx.dadosEmpresa.codigoEmpresa,
        aberturaCaixa: _ctx.computedAberturaCaixa,
        "onUpdate:aberturaCaixa": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.computedAberturaCaixa) = $event)),
        onConfirmar: _ctx.atualizarCaixa
      }, null, 8, ["visivel", "empresa", "aberturaCaixa", "onConfirmar"]),
      _createVNode(_component_fechamento_caixa_modal, {
        visivel: _ctx.state.exibirFechamentoCaixa,
        "onUpdate:visivel": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.state.exibirFechamentoCaixa) = $event)),
        empresa: _ctx.dadosEmpresa.codigoEmpresa,
        abertura: _ctx.computedAberturaCaixa,
        "onUpdate:abertura": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.computedAberturaCaixa) = $event)),
        caixa: _ctx.state.caixa,
        onConfirmacao: _ctx.atualizarCaixa
      }, null, 8, ["visivel", "empresa", "abertura", "caixa", "onConfirmacao"])
    ]),
    _: 1
  }, 8, ["visible"]))
}